// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  totalTags: 1,
  params: {},
  selectedUser: null,
  info: [],
  error: null,
};
const TagsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ALL_TAGS":
      return {
        ...state,
        allData: action.allData,
        data: action.data,
        total: action.totalPages,
      };
    case "GET_TAGS":
      return {
        ...state,
        allData: action.allData,
        data: action.data,
        total: action.totalPages,
        params: action.params,
        info: action.info,
        totalTags: action.totalTags,
      };
    case "EMPTY_ERROR":
    case "ADD_TAGS_SUCCESS":
    case "EDIT_TAGS_SUCCESS":
      return { ...state, error: null };
    case "ADD_TAGS_FAIL":
    case "EDIT_TAGS_FAIL":
      return { ...state, error: action.payload };
    default:
      return { ...state };
  }
};

export default TagsReducer;
